var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-3xl-5 com:text-5xl-5 com:font-semibold leading-snug com:leading-tight h-full flex items-center"},[_c('div',[_c('div',{staticClass:"max-4-lines com:pr-16"},[_vm._v(" "+_vm._s(_vm.content.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }